import { render } from "./parent-form.vue?vue&type=template&id=eb307dc8&lang=true"
import script from "./parent-form.vue?vue&type=script&lang=js"
export * from "./parent-form.vue?vue&type=script&lang=js"

import "./parent-form.vue?vue&type=style&index=0&id=eb307dc8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__